export const TECHNOLOGY_PACKAGES = 'Technology_Packages.Technologie_Pakete';
